<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">




    <div class="col-6 mt-3"> 


          <!-- Button trigger modal -->
<button type="button" @click="addModule()" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
 დამატება
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      
        <div class="mb-3 mt-3">
  
  <input type="text" class="form-control " placeholder=" მოდულის სახელი" v-model="module_name">
 
</div>

     
<div class="mb-3 mt-3">
  
 <textarea class="form-control" v-model="description" placeholder="აღწერა"></textarea>
 
</div>


      </div>
      <div class="modal-footer">
        
        <button type="button" v-if="!editableRow" class="btn btn-success"  @click="savemodule()">შენახვა</button>
        <button type="button" v-else class="btn btn-success"  @click="editmodule(editModuleID)">რედაქტირება</button>
      </div>
    </div>
  </div>
</div>
 
           
         
        </div> 
             <div class="col-12 mt-3">
 
                 <table class="table">
   <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col"> მოდულის სახელი</th>
       <th scope="col"> აღწერა</th>
       <th></th>
      
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="module in modules" :key="module.moduleID">
       <th scope="row">{{ module.moduleID }}</th>
       <td><span >{{module.module_name}}</span> </td>
       <td><span >{{module.description}}</span> </td>
       <td><button type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="getRowForEdit(module.module_name,module.moduleID,module.description)" class="btn btn-outline-success"><i class='bx bxs-edit-alt'></i></button> </td>
       
    
     </tr>
     
   
 
   </tbody>
 </table>
             </div> 
 
     </div>
    </div>
  
 
 </template>
 <script>
import HttpRequests from '../httpRequests/httpRequests';
const httpRequests=new HttpRequests()

export default{

data(){
return{
  modules:[],
  module_name:null,
  editableRow:false,
  editModuleID:0,
  description:null
  
  

}

},

mounted(){
  httpRequests.getModule().then(response=>{
    this.modules=response.data
})
},
methods:{
  savemodule(){
    httpRequests.savemodule(this.module_name).then(()=> {
      location.reload()
    })
  },

  getRowForEdit(module_name,moduleID,description){
    this.editableRow=true
    this.module_name=module_name
    this.editModuleID=moduleID
    this.description=description
  },
  addModule(){
    this.editableRow=false
    this.module_name=null
    this.editModuleID=0
    this.description=null
  },
  editmodule(moduleID){

    httpRequests.editModule(moduleID,this.module_name,this.description).then(()=>{
      location.reload()
    })
 
  }

}

}





</script>
